import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { assert_array_includes } from '@shared/asserts/utils_asserts';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UI_PRIMITIVE__tooltip } from '../../../../components/ui/UI_PRIMITIVE__tooltip';
import { PROPS__button_navigation } from '../button_wrappers/PROPS__button_navigation';
import { WatcherShortcutPageNavigation } from './watcher_shortcut_page_navigation';

export function BUTTON__navigation_desktop({
  page_type,
  tooltip_title,
  Icon,
  disabled,
  title,
  shortcut_key_codes = [],
  is_animation_enabled = false,
}: PROPS__button_navigation) {
  assert_array_includes(Object.values(ENUM__page_type), page_type);

  const navigate = useNavigate();
  const location = useLocation();

  const { global_need_show_first_animation } = use_slice_ui(['global_need_show_first_animation']);

  const [is_hovered, set_is_hovered] = useState(false);

  let is_page_opened = useMemo(() => location.pathname.includes(page_type), [location.pathname, page_type]);

  const { on_user_uses_component, on_user_uses_shortcut } = use_hint_shortcut(EShortcutType.NAVIGATION_HOTKEYS_BETWEEN_PAGES);

  /*
   * EVENTS
   */

  async function onClick() {
    on_user_uses_component();

    await navigate(page_type);
  }

  /*
   * RENDERS
   */

  function render_icon() {
    let className = `hover-animation-important !size-4 !text-bar-foreground
            ${is_page_opened || disabled ? '!text-bar-foreground !opacity-25' : ''}
            ${global_need_show_first_animation ? '' : '!opacity-0 !scale-50'} 
            ${!(is_page_opened || disabled) && `${is_hovered ? '!text-bar-foreground-hover' : '!text-component-item-foreground'}`}
            ${is_animation_enabled ? '!scale-125 !text-bar-foreground-hover' : ''}
            `;

    let out = <Icon {...{ className }} />;

    return out;
  }

  /*
   * HTML
   */
  return (
    <>
      {shortcut_key_codes.length > 0 && <WatcherShortcutPageNavigation {...{ page_type, key_codes: shortcut_key_codes }} />}
      <div
        onMouseEnter={() => set_is_hovered(true)}
        onMouseLeave={() => set_is_hovered(false)}
        onClick={() => void onClick()}
        className={`p-2 cursor-pointer flex-center   rounded-lg 
          ${is_page_opened || (is_hovered && !disabled) ? 'bg-component' : ''} `}
      >
        <UI_PRIMITIVE__tooltip {...{ tooltip_title }} side="right">
          <span className="flex-inline flex-shrink-0">{render_icon()}</span>
        </UI_PRIMITIVE__tooltip>
      </div>
    </>
  );
}
